let lockCount = 0;
let restoreScroll;

// 多个弹窗共用一个锁，最后一个关闭后才恢复页面。
export default function lockPageScroll() {
  if (lockCount === 0) {
    const html = document.documentElement;
    const body = document.body;
    const x = window.pageXOffset;
    const y = window.pageYOffset;
    const saved = [];
    const setStyle = (element, property, value) => {
      saved.push([element, property, element.style.getPropertyValue(property), element.style.getPropertyPriority(property)]);
      element.style.setProperty(property, value, 'important');
    };

    setStyle(html, 'scroll-behavior', 'auto');
    setStyle(body, 'scroll-behavior', 'auto');
    setStyle(html, 'overflow', 'hidden');
    setStyle(body, 'overflow', 'hidden');
    // 固定 body，兼容移动端只设置 overflow 仍能滚动的情况。
    setStyle(body, 'position', 'fixed');
    setStyle(body, 'top', `${-y}px`);
    setStyle(body, 'left', `${-x}px`);
    setStyle(body, 'width', '100%');

    restoreScroll = () => {
      const restore = ([element, property, value, priority]) => {
        if (value) element.style.setProperty(property, value, priority);
        else element.style.removeProperty(property);
      };
      saved
        .slice(2)
        .reverse()
        .forEach(restore);
      window.scrollTo(x, y);
      saved.slice(0, 2).forEach(restore);
    };
  }
  lockCount += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    lockCount -= 1;
    if (lockCount === 0) {
      restoreScroll();
      restoreScroll = null;
    }
  };
}
